<template>
  <div :class="fullscreen ? 'mega-login-screen' : 'mega-login-overlay'">
    <select v-if="fullscreen" class="mega-language" aria-label="언어 / Language" :value="$i18n.locale" @change="changeLocale($event.target.value)">
      <option value="ko">한국어</option>
      <option value="en">English</option>
    </select>
    <div class="mega-login-shell">
      <img class="mega-login-logo" src="@/assets/img/mega-login-logo.png" alt="메가 CASINO" />
      <form class="mega-login-panel" aria-labelledby="mega-login-title" :aria-busy="isSubmitting" @submit.prevent="onSubmit">
        <button v-if="!fullscreen" class="mega-login-close" type="button" aria-label="닫기" @click="$emit('close')"><img src="@/assets/img/icon_x.svg" alt="" /></button>
        <div class="mega-login-heading">
          <h1 id="mega-login-title">LOGIN</h1>
          <p>{{ $t('front.gnb.login') }}</p>
        </div>
        <div class="mega-login-fields">
          <label for="mega-mem-id">{{ $t('front.common.memId') }}</label>
          <input id="mega-mem-id" v-model="model.memId" name="username" autocomplete="username" autocapitalize="none" :spellcheck="false" :placeholder="$t('front.common.memId')" />
          <label for="mega-mem-pass">{{ $t('front.common.password') }}</label>
          <input id="mega-mem-pass" v-model="model.memPass" name="password" type="password" autocomplete="current-password" :placeholder="$t('front.common.password')" />
          <div class="captcha-box">
           <VueClientRecaptcha
               :value="inputValue"
               :count="4"
               chars="12345"
               :hideLines="true"
               custom-text-color="black"
               @getCode="getCaptchaCode"
               @isValid="checkValidCaptcha"
           >
           </VueClientRecaptcha>
           <input
               v-model="inputValue"
               placeholder="자동입력방지코드"
               aria-label="자동입력방지코드"
               class="input"
               type="text"
               inputmode="numeric"
               autocomplete="off"
               maxlength="4"
           />
          </div>
          <div class="mega-login-actions">
            <button class="mega-join-button" type="button" :disabled="isSubmitting" @click="$emit('close', 'join')">{{ $t('front.common.signup') }}</button>
            <button class="mega-submit-button" type="submit" :disabled="isSubmitting">{{ isSubmitting ? ($i18n.locale === 'ko' ? '로그인 중…' : 'Signing in…') : $t('front.gnb.login') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import { signIn } from '@/api/member'
import { setAuthData } from '@/libs/auth-helper'
import store from '@/store'

import VueClientRecaptcha from 'vue-client-recaptcha'

export default {
  name: 'Signin',
  props: {
    fullscreen: Boolean
  },
  emits: ['close', 'signup'],
  components: {
    VueClientRecaptcha
  },
  computed: {
    canSubmit () {
      return this.model.memId && this.model.memPass
    }
  },
  data () {
    return {
      isSubmitting: false,
      model: {
        memId: '',
        memPass: ''
      },
      data: {
        captchaCode: null,
        isValid: false
      },
      inputValue: null
    }
  },
  methods: {
    onAlert (level, message) {
      this.onNotice(message, '로그인 실패')
    },
    getCaptchaCode (value) {
      this.data.captchaCode = value
    },
    checkValidCaptcha (value) {
      this.data.isValid = value
    },
    setReloadCaptcha () {
      setTimeout(() => {
        if (document.querySelector('.vue_client_recaptcha_icon')) {
          document.querySelector('.vue_client_recaptcha_icon').click()
        }
      }, 500)
    },
    async onSubmit () {
      if (this.isSubmitting) return
      if (!this.data.isValid) {
        this.onAlert('warningart', '자동 입력 방지 코드를 확인해주세요.')
        this.setReloadCaptcha()
        return false
      }

      if (this.model.memId === '') {
        this.onAlert('warningart', 'front.signin.emptyMemId')
        this.setReloadCaptcha()
        return false
      }
      if (this.model.memPass === '') {
        this.onAlert('warningart', 'front.signin.emptyMemPass')
        this.setReloadCaptcha()
        return false
      }

      if (!this.canSubmit) {
        this.setReloadCaptcha()
        return false
      }

      /*
      * api/member.js 참고
      */
      this.isSubmitting = true
      return signIn(this.model).then(async response => {
        const result = response.data
        const data = result.data

        if (result.resultCode === '0') {
          this.onNotice(null)
          setAuthData(data)
          store.commit('setUserData', data.member)
          return store.dispatch('storeCommonCode').then(commonCode => {
            if (data.msgInfo) {
              store.dispatch('storeUserUnReadMessageCount', data.msgInfo.newMsg)
            }
            this.$emit('close', 'signin')
          })

          // setTimeout(function () {
          //   this.$emit('close', 'signin')
          // }.bind(this), 100)
        } else if (result.resultCode === 'U001' || result.resultCode === 'LX02') {
          this.onAlert('warningart', 'err.' + result.resultCode)
          this.setReloadCaptcha()
        } else {
          // const confirm = await this.onConfirm('api.' + result.resultCode)
          // if (confirm) {
          //   this.$emit('signup')
          // }
          this.onAlert('warningart', '로그인에 실패하였습니다. ID/PW를 확인해 주시기 바랍니다.')
          this.setReloadCaptcha()
        }
      }).catch(err => {
        console.error('login err : ', err.message)

        if (err.message === 'no member') {
          // alert('로그인정보가 올바르지 않습니다. 확인해주세요.')
          this.onAlert('warningart', '로그인에 실패하였습니다. ID/PW를 확인해 주시기 바랍니다.')
        } else {
          this.onAlert('warningart', '서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.')
        }
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'Mega SUIT';
  src: url('../../assets/fonts/sunn-main/SUIT-Regular.woff2') format('woff2');
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: 'Mega SUIT';
  src: url('../../assets/fonts/sunn-main/SUIT-Bold.woff2') format('woff2');
  font-weight: 700;
  font-display: swap;
}
.mega-login-screen, .mega-login-overlay {
  box-sizing: border-box;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  padding: 28px 20px 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Mega SUIT', Arial, sans-serif;
  color: #e4eaf0;
  line-height: 1.4;
}
.mega-login-screen {
  background: #b9daf2 url('../../assets/img/mega-login-curtains.png') center center / cover no-repeat;
}
.mega-login-overlay {
  position: fixed;
  inset: 0;
  height: 100%;
  overflow-y: auto;
  z-index: 100;
  background: rgb(0 0 0 / 65%);
}
.mega-language {
  position: absolute;
  right: 12px;
  top: 8px;
  color: #fff;
  background: rgb(31 52 71 / 75%);
  border: 1px solid #c5d6e3;
  padding: 7px 12px;
  font: inherit;
  font-size: 12px;
}
.mega-login-shell { width: min(100%, 528px); position: relative; padding-top: 236px; }
.mega-login-logo {
  position: absolute;
  z-index: 1;
  width: 470px;
  max-width: 100%;
  height: 354px;
  object-fit: contain;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}
.mega-login-panel {
  position: relative;
  box-sizing: border-box;
  margin: 0;
  padding: 128px 60px 30px;
  border: 4px solid #ad86f8;
  border-top-color: #96e8d9;
  border-left-color: #96e8d9;
  border-radius: 16px;
  background: rgb(24 35 52 / 69%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  box-shadow: 0 9px 27px rgb(71 128 180 / 25%);
}
.mega-login-heading { text-align: center; padding-bottom: 21px; margin-bottom: 20px; border-bottom: 1px solid rgb(217 229 240 / 20%); }
.mega-login-heading h1 { font-size: 32px; line-height: 1.15; font-weight: 700; color: #bdfff0; text-shadow: 0 0 15px #69e4d6; }
.mega-login-heading p { margin-top: 3px; font-size: 20px; }
.mega-login-fields label { display: block; text-align: left; margin: 12px 0 5px; font-size: 16px; font-weight: 700; }
.mega-login-fields input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  height: 48px;
  border: 2px solid #a0a0a0;
  border-radius: 8px;
  background: #333;
  padding: 0 9px;
  color: #fff;
  font: inherit;
  font-size: 16px;
}
.mega-login-fields input::placeholder { color: #b9b9b9; opacity: 1; }
.captcha-box { margin-top: 16px; display: flex; gap: 8px; align-items: center; }
.captcha-box :deep(.vue_client_recaptcha) { width: 46%; flex-shrink: 0; height: 40px; display: flex; align-items: center; justify-content: center; background: #fff; border-radius: 5px; overflow: hidden; }
.captcha-box :deep(canvas) { max-width: calc(100% - 30px); height: 40px; }
.captcha-box .input { height: 40px; font-size: 13px; text-align: center; }
.mega-login-actions { display: flex; gap: 8px; margin-top: 18px; }
.mega-login-actions button { flex: 1; min-width: 0; height: 50px; border: 0; border-radius: 8px; color: #191830; font: inherit; font-size: 19px; font-weight: 700; cursor: pointer; }
.mega-join-button { background: #c78df3; }
.mega-submit-button { background: #a59bf6; }
.mega-login-actions button:hover:not(:disabled) { filter: brightness(1.1); }
.mega-login-actions button:disabled { opacity: .65; cursor: wait; }
.mega-login-close { position: absolute; right: 12px; top: 12px; background: transparent; border: 0; padding: 10px; cursor: pointer; z-index: 2; }
.mega-login-close img { width: 18px; height: 18px; }
input:focus-visible, button:focus-visible, select:focus-visible { outline: 3px solid #bffff0; outline-offset: 3px; }
@media (max-width: 600px) {
  .mega-login-screen, .mega-login-overlay { padding: 48px 16px 28px; }
  .mega-login-shell { padding-top: 164px; max-width: 420px; }
  .mega-login-logo { height: 255px; width: 340px; }
  .mega-login-panel { padding: 106px 24px 30px; }
  .mega-login-heading { margin-bottom: 22px; padding-bottom: 18px; }
  .mega-login-heading h1 { font-size: 28px; }
  .mega-login-actions button { font-size: 17px; }
}
</style>
